import { gql } from '@apollo/client';

export const CORE_USER_FIELDS = gql`
  fragment CoreUserFields on User {
    id
    firstName
    lastName
    bun
    employeeImageUrl
  }
`;

export const GET_APP_USER = gql`
  ${CORE_USER_FIELDS}
  query AppUser {
    appUser {
      ...CoreUserFields
      etrackId
      roles {
        id
        description
        name
      }
      projects {
        id
        name
        isActive
      }
    }
  }
`;

// TODO: Filter users based on role
export const SEARCH_USERS = gql`
  ${CORE_USER_FIELDS}
  query SearchUsers($searchInput: SearchInput!) {
    searchUsers(searchInput: $searchInput) {
      items {
        ...CoreUserFields
        roles {
          id
          description
          name
        }
        employee {
          id
          persona
          imageUrl
        }
      }
    }
  }
`;

export const GET_USER = gql`
  ${CORE_USER_FIELDS}
  query UserDetail($userId: ID!) {
    userById(id: $userId) {
      ...CoreUserFields
      roles {
        id
        description
        name
      }
      toolRooms {
        id
        barCode
        description
        name
      }
      upn
      isActive
      employee {
        id
        persona
        imageUrl
        lobEmployeeId
        thUserId
        toolHoundId
        updatedDate
        exemptedFromImport
        thRole
        supervisor {
          lobEmployeeId
          firstName
          lastName
          id
          user {
            id
            bun
          }
        }
      }
    }
  }
`;

export const UPDATE_USER = gql`
  ${CORE_USER_FIELDS}
  mutation UpdateUserAccount($updateUserAccountInput: UpdateUserAccountInput!) {
    updateUserAccount(updateUserAccountInput: $updateUserAccountInput) {
      error
      userAccount {
        ...CoreUserFields
        roles {
          id
          description
          name
        }
        upn
        isActive
        employee {
          id
          persona
          imageUrl
          lobEmployeeId
          thUserId
          toolHoundId
          exemptedFromImport
          thRole
          supervisor {
            id
            firstName
            lastName
            lobEmployeeId
            user {
              id
              bun
            }
          }
        }
        toolRooms {
          id
          barCode
          description
          name
          isActive
          adhocEnabled
          transferEnabled
        }
      }
    }
  }
`;
export const CREATE_USER = gql`
  ${CORE_USER_FIELDS}
  mutation CreateUserAccount($createUserAccountInput: CreateUserAccountInput!) {
    createUserAccount(createUserAccountInput: $createUserAccountInput) {
      error
      userAccount {
        ...CoreUserFields
        roles {
          id
          description
          name
        }
        upn
        isActive
        employee {
          id
          persona
          imageUrl
          lobEmployeeId
          thUserId
          toolHoundId
          exemptedFromImport
          thRole
          supervisor {
            id
            firstName
            lastName
            lobEmployeeId
            user {
              id
              bun
            }
          }
        }
      }
    }
  }
`;
export const GET_TOTAL_USER_COUNT = gql`
  query Query($searchInput: SearchInput) {
    usersCountForSearch(searchInput: $searchInput)
  }
`;
